export const dummyConstant = 'avron-quizzes-constant';

export const fontOptions = [
    {
        text: 'Helvetica',
        value: "'Helvetica', sans-serif"
    },
    {
        text: 'Arial',
        value: "'Arial', sans-serif"
    },
    {
        text: 'Arial Black',
        value: "'Arial Black', sans-serif"
    },
    {
        text: 'Verdana',
        value: "'Verdana', sans-serif"
    },
    {
        text: 'Tahoma',
        value: "'Tahoma', sans-serif"
    },
    {
        text: 'Trebuchet MS',
        value: "'Trebuchet MS', sans-serif"
    },
    {
        text: 'Impact',
        value: "'Impact', sans-serif"
    },
    {
        text: 'Gill Sans',
        value: "'Gill Sans', sans-serif"
    },
    {
        text: 'Times New Roman',
        value: "'Times New Roman', serif"
    },
    {
        text: 'Georgia',
        value: "'Georgia', serif"
    },
    {
        text: 'Palatino',
        value: "'Palatino', serif"
    },
    {
        text: 'Baskerville',
        value: "'Baskerville', serif"
    },
    {
        text: 'Andalé Mono',
        value: "'Andalé Mono', monospace"
    },
    {
        text: 'Courier',
        value: "'Courier', monospace"
    },
    {
        text: 'Lucida',
        value: "'Lucida', monospace"
    },
    {
        text: 'Monaco',
        value: "'Monaco', monospace"
    },
    {
        text: 'Bradley Hand',
        value: "'Bradley Hand', cursive"
    },
    {
        text: 'Brush Script MT',
        value: "'Brush Script MT', cursive"
    },
    {
        text: 'Luminari',
        value: "'Luminari', fantasy"
    },
    {
        text: 'Comic Sans MS',
        value: "'Comic Sans MS', cursive"
    },
    {
        text: 'Akronim',
        value: "'Akronim', cursive"
    },
    {
        text: 'Alfa Slab One',
        value: "'Alfa Slab One', cursive"
    },
    {
        text: 'Anton',
        value: "'Anton', sans-serif"
    },
    {
        text: 'Arbutus',
        value: "'Arbutus', cursive"
    },
    {
        text: 'Bebas Neue',
        value: "'Bebas Neue', cursive"
    },
    {
        text: 'Bungee Outline',
        value: "'Bungee Outline', cursive"
    },
    {
        text: 'Corinthia',
        value: "'Corinthia', cursive"
    },
    {
        text: 'Covered By Your Grace',
        value: "'Covered By Your Grace', cursive"
    },
    {
        text: 'Dancing Script',
        value: "'Dancing Script', cursive"
    },
    {
        text: 'Eagle Lake',
        value: "'Eagle Lake', cursive"
    },
    {
        text: 'Explora',
        value: "'Explora', cursive"
    },
    {
        text: 'Festive',
        value: "'Festive', cursive"
    },
    {
        text: 'Fredericka the Great',
        value: "'Fredericka the Great', cursive"
    },
    {
        text: 'Gloria Hallelujah',
        value: "'Gloria Hallelujah', cursive"
    },
    {
        text: 'Indie Flower',
        value: "'Indie Flower', cursive"
    },
    {
        text: 'Joti One',
        value: "'Joti One', cursive"
    },
    {
        text: 'Kanit',
        value: "'Kanit', sans-serif"
    },
    {
        text: 'Kumar One',
        value: "'Kumar One', cursive"
    },
    {
        text: 'Lobster',
        value: "'Lobster', cursive"
    },
    {
        text: 'Marck Script',
        value: "'Marck Script', cursive"
    },
    {
        text: 'Monoton',
        value: "'Monoton', cursive"
    },
    {
        text: 'Montserrat',
        value: "'Montserrat', sans-serif"
    },
    {
        text: 'Moon Dance',
        value: "'Moon Dance', cursive"
    },
    {
        text: 'Mystery Quest',
        value: "'Mystery Quest', cursive"
    },
    {
        text: 'Nosifer',
        value: "'Nosifer', cursive"
    },
    {
        text: 'Noto Serif Toto',
        value: "'Noto Serif Toto', serif"
    },
    {
        text: 'Open Sans',
        value: "'Open Sans', sans-serif"
    },
    {
        text: 'Pacifico',
        value: "'Pacifico', cursive"
    },
    {
        text: 'Paprika',
        value: "'Paprika', cursive"
    },
    {
        text: 'Permanent Marker',
        value: "'Permanent Marker', cursive"
    },
    {
        text: 'Plaster',
        value: "'Plaster', cursive"
    },
    {
        text: 'Press Start 2P',
        value: "'Press Start 2P', cursive"
    },
    {
        text: 'Qwigley',
        value: "'Qwigley', cursive"
    },
    {
        text: 'Ribeye Marrow',
        value: "'Ribeye Marrow', cursive"
    },
    {
        text: 'Roboto',
        value: "'Roboto', sans-serif"
    },
    {
        text: 'Roboto Condensed',
        value: "'Roboto Condensed', sans-serif"
    },
    {
        text: 'Rubik Beastly',
        value: "'Rubik Beastly', cursive"
    },
    {
        text: 'Rubik Gemstones',
        value: "'Rubik Gemstones', cursive"
    },
    {
        text: 'Rubik Glitch',
        value: "'Rubik Glitch', cursive"
    },
    {
        text: 'Rubik Vinyl',
        value: "'Rubik Vinyl', cursive"
    },
    {
        text: 'Rubik Wet Paint',
        value: "'Rubik Wet Paint', cursive"
    },
    {
        text: 'Sancreek',
        value: "'Sancreek', cursive"
    },
    {
        text: 'Sarina',
        value: "'Sarina', cursive"
    },
    {
        text: 'Sedgwick Ave Display',
        value: "'Sedgwick Ave Display', cursive"
    },
    {
        text: 'Space Grotesk',
        value: "'Space Grotesk', sans-serif"
    },
    {
        text: 'Train One',
        value: "'Train One', cursive"
    },
    {
        text: 'Underdog',
        value: "'Underdog', cursive"
    },
    {
        text: 'WindSong',
        value: "'WindSong', cursive"
    }
];
